import styled from "@emotion/styled";

export const PromotionalRibbonWrapper = styled.div<{
  backgroundColor?: string;
  textColor?: string;
  highlightColor?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  place-items: center;
  place-content: center;
  width: 100%;
  height: ${({ theme }) => theme.space.space48};
  background-color: ${({ backgroundColor }) => backgroundColor || "#990001"};
  padding: ${({ theme }) => `0 ${theme.space.space8 || 0}`};
  z-index: 1424;

  .message {
    display: flex;
    place-items: center;
    place-content: center;
    gap: 2px;
    flex: 1;
    margin-left: ${({ theme }) => theme.space.space32};

    color: ${({ theme, textColor }) => textColor || theme.colors.tone.white};
    font-weight: 600;

    svg path {
      stroke: ${({ theme, highlightColor }) =>
        highlightColor || theme.colors.tone.white};
    }
  }

  .actions {
    display: flex;
    place-items: center;
    place-content: center;
  }
`;
